/**
 * Correções para o carrinho lateral
 * Este arquivo contém correções para erros específicos no carrinho lateral
 */

// Verificar se setupQuantityInputs existe e implementá-lo se não existir
if (typeof window.setupQuantityInputs !== 'function') {
  window.setupQuantityInputs = function() {
    // Selecionar inputs de quantidade dentro do carrinho personalizado
    const quantityInputs = document.querySelectorAll('#CartDrawerCustom .cart-drawer-item-quantity-input');
    
    if (quantityInputs.length > 0) {
      console.log(`Configurando ${quantityInputs.length} inputs de quantidade`);
      
      quantityInputs.forEach(input => {
        // Remover listeners antigos clonando o elemento
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);
        
        // Adicionar novo listener para atualizar a quantidade quando o valor mudar
        newInput.addEventListener('change', function() {
          const itemKey = this.getAttribute('data-cart-item-key');
          const newQuantity = parseInt(this.value, 10);
          
          if (itemKey && !isNaN(newQuantity) && newQuantity >= 0) {
            if (typeof updateCartItemQuantity === 'function') {
              updateCartItemQuantity(itemKey, newQuantity);
            }
          }
        });
      });
    }
  };
  console.log('Função setupQuantityInputs implementada globalmente');
}

// Corrigir a função rebindCartEvents para verificar se setupQuantityInputs existe
document.addEventListener('DOMContentLoaded', function() {
  // Aguardar um momento para garantir que o script principal seja carregado
  setTimeout(function() {
    // Verificar se rebindCartEvents existe e modificá-lo
    if (typeof window.rebindCartEvents === 'function') {
      // Salvar a função original
      const originalRebindCartEvents = window.rebindCartEvents;
      
      // Substituir com uma versão que verifica se setupQuantityInputs existe
      window.rebindCartEvents = function() {
        console.log('Versão corrigida de rebindCartEvents executada');
        
        // Chamar a função original
        originalRebindCartEvents.apply(this, arguments);
        
        // Garantir que setupQuantityInputs seja chamado corretamente
        if (typeof window.setupQuantityInputs === 'function') {
          window.setupQuantityInputs();
        }
      };
      
      console.log('Função rebindCartEvents corrigida');
    }
  }, 500);
});
